import { initializeMultiDropdown } from '../components/dropdowns/MultiDropdown';

class Courses {
    constructor() {
        initializeMultiDropdown();
    }
}

export default Courses;
